import React from "react";

const Button = ({
  btnClassName,
  btnText,
  icon: Icon,
  onClick,
  type = "button",
  disabled = false,
}) => {
  return (
    <div>
      <button
        className={`${btnClassName} flex items-center transition-colors duration-200 justify-center  gap-4`}
        onClick={onClick}
        type={type}
        disabled={disabled}
      >
        {Icon && <Icon />} {btnText}
      </button>
    </div>
  );
};

export default Button;
